import { 
    findRemission, 
    remissionPDF,
    findRemissionsFact,
    findAllRemissionsOrderByDate,
    remissionPDFByUuid,
    remissionExcelByMonthYear
} from '../../_services/remission.service';

export const findRemissionEvent = async () => {
    let res = await findRemission();
    if(! res.ok) throw new Error(res.error);
    return res;
}
export const remissionPDFEvent = async (remission) => {
    const body={
        remission
    }
    let res = await remissionPDF(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const remissionExcelByMonthYearEvent = async (month, year) => {
    let res = await remissionExcelByMonthYear(month, year);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findRemissionsFactEvent = async () => {
    let res = await findRemissionsFact();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findAllRemissionsOrderByDateEvent = async () => {
    let res = await findAllRemissionsOrderByDate();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const remissionPDFByUuidEvent = async (uuid) => {
    let res = await remissionPDFByUuid(uuid);
    if(! res.ok) throw new Error(res.error);
    return res;
}





